<div class="example-container">
  <mat-toolbar
    [fxShow]="
      !(gatewayService.isHome$ | async) && (gatewayService.isLoggedIn$ | async)
    "
    class="example-toolbar mat-elevation-z10"
  >
    <div class="top_navigation">
      <div class="top_navigation-left">
        <em
          class="ti-menu"
          style="cursor: pointer;"
          (click)="sidenav.toggle()"
          fxShow="true"
        ></em>
        <div class="logo">
          <!-- <img src="assets/images/shell-4-logo-png-transparent.png" alt="" /> -->
          <h3 class="company">{{ SubscriberName }}</h3>
        </div>
      </div>

      <div class="top_navigation-right">
        <em  class="ti-layout-grid3-alt" [matMenuTriggerFor]="menu1"></em>

        <mat-menu #menu1="matMenu">
          <button mat-menu-item>
            <mat-icon>dialpad</mat-icon>
            <span>LIS</span>
          </button>
          <button mat-menu-item disabled>
            <mat-icon>voicemail</mat-icon>
            <span>Pipeline Licence Management</span>
          </button>
        </mat-menu>

        <div class="user" [matMenuTriggerFor]="menu" style="cursor: pointer;">
          <!-- <div class="user_image"></div> -->
          <span class="user_name"
            >{{ StaffName }}
            <em  class="ti-angle-down"></em>
            <!-- <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                <mat-icon>more_vert</mat-icon>
              </button> -->
          </span>
        </div>
        <mat-menu #menu="matMenu">
          <button
            mat-menu-item
            (click)="logOut()"
            style="border: none; outline: none;"
          >
            <mat-icon>notifications_off</mat-icon>
            <span (click)="logOut()">Log Out</span>
          </button>
        </mat-menu>
      </div>
    </div>
  </mat-toolbar>
  <mat-sidenav-container
    [hasBackdrop]="false"
    [ngStyle]="{ 'margin-top': isHome ? '0px' : '0px' }"
    class="side_nav example-sidenav-container"
  >
    <!-- SIDENAV -->

    <mat-sidenav
      #sidenav
      [(mode)]="over"
      [(opened)]="opened"
      class="side_nav--menu no-v-scroll"
      style="width: 240px; border: 0px;"
      [fxShow]="
        !(gatewayService.isHome$ | async) &&
        (gatewayService.isLoggedIn$ | async)
      "
    >
      <!-- SIDENAV-HEADER-TOOLBAR -->

      <!--SIDENAV-BODY-CONTENT -->
      <div class="logo">
        <em
          class="ti-close"
          (click)="sidenav.toggle()"
          style="cursor: pointer;"
        ></em>
        EPIMS
      </div>
      <div style="overflow-y: auto;" class="mt-3">
        <mat-accordion
          multi="true"
          [displayMode]="displayMode"
          *ngFor="let role of roles; let i = index"
        >
          <mat-expansion-panel
            class="no-shadow mat-elevation-z0 mat-expansion-panel-nav"
            style="background: none;"
          >
            <mat-expansion-panel-header
              class="specific-class p-0"
              fxLayout="row"
              [expandedHeight]="expandHeight"
              [collapsedHeight]="collapseHeight"
            >
              <mat-panel-title class="panel-title nav-link">
                <img
                  src="assets/images/side_nav/User.svg"
                  height="60%"
                  alt=""
                />

                <span
                  *ngIf="role.role.link.length == 0"
                  class="nav__list ml-3"
                  >{{ role.role.name }}</span
                >

                <a
                  *ngIf="role.role.link.length > 0"
                  class="collapse-item"
                  [routerLink]="role.role.link"
                  >{{ role.role.name }}</a
                >
              </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-nav-list dense>
              <div *ngFor="let child of role.children; let j = index">
                <div *ngIf="child.role.link.length == 0">
                  <mat-accordion multi="true" [displayMode]="displayMode">
                    <mat-expansion-panel
                      class="no-shadow mat-elevation-z0 mat-expansion-panel-nav"
                      style="background: none;"
                    >
                      <mat-expansion-panel-header
                        class="specific-class p-0"
                        fxLayout="row"
                        [expandedHeight]="expandHeight"
                        [collapsedHeight]="collapseHeight"
                      >
                        <mat-panel-title class="panel-title nav-link">
                          <img
                            src="assets/images/side_nav/employee.svg"
                            height="60%"
                            alt=""
                          />

                          <span class="nav__list ml-3">{{
                            child.role.name
                          }}</span>
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <mat-nav-list dense>
                        <div
                          *ngFor="
                            let grandchild of child.grandchildren;
                            let k = index
                          "
                        >
                          <a
                            [routerLink]="[grandchild.role.link]"
                            style="text-decoration: none;"
                            ><mat-list-item class="nav-link">{{
                              grandchild.role.name
                            }}</mat-list-item>
                          </a>
                        </div>
                      </mat-nav-list>
                    </mat-expansion-panel>
                  </mat-accordion>
                </div>
                <div *ngIf="child.role.link.length > 0">
                  <a
                    [routerLink]="[child.role.link]"
                    style="text-decoration: none;"
                    ><mat-list-item class="nav-link">{{
                      child.role.name
                    }}</mat-list-item>
                  </a>
                  <!-- <mat-list-item class="nav-link ">
                                <a class="collapse-item" [routerLink]="child.role.link">{{child.role.name}}</a>
                              </mat-list-item> -->
                </div>
              </div>
            </mat-nav-list>
          </mat-expansion-panel>
        </mat-accordion>

        <mat-accordion *ngIf="user">
          <mat-expansion-panel class="mat-elevation-z0" hideToggle #example2 *ngIf="user.UserType == 'Subscriber'">
            <mat-expansion-panel-header>
              <mat-panel-title class="panel-title">
                <span class="link_image"
                  ><img
                    src="assets/images/side_nav/employee.svg"
                    width="20"
                    height="18"
                    alt=""
                /></span>
                Roles Management
              </mat-panel-title>
              <mat-icon *ngIf="!example2.expanded"
                >keyboard_arrow_down</mat-icon
              >
              <mat-icon *ngIf="example2.expanded"
                >keyboard_arrow_right</mat-icon
              >
            </mat-expansion-panel-header>
            <mat-list>
              <a [routerLink]="['/staffroles']" style="text-decoration: none;"
                ><mat-list-item>Roles Management</mat-list-item>
              </a>
            </mat-list>
          </mat-expansion-panel>
        </mat-accordion>

        <mat-accordion style="display: none;">
          <mat-expansion-panel class="mat-elevation-z0" hideToggle #example2>
            <mat-expansion-panel-header>
              <mat-panel-title class="panel-title">
                <span class="link_image"
                  ><img
                    src="assets/images/side_nav/employee.svg"
                    width="20"
                    height="18"
                    alt=""
                /></span>
                Acquisition Management
              </mat-panel-title>
              <mat-icon *ngIf="!example2.expanded"
                >keyboard_arrow_down</mat-icon
              >
              <mat-icon *ngIf="example2.expanded"
                >keyboard_arrow_right</mat-icon
              >
            </mat-expansion-panel-header>
            <mat-list>
              <a [routerLink]="['/acquisition']" style="text-decoration: none;"
                ><mat-list-item>Land Acquisition</mat-list-item>
              </a>
            </mat-list>
          </mat-expansion-panel>

          <mat-expansion-panel class="mat-elevation-z0" hideToggle #example3>
            <mat-expansion-panel-header>
              <mat-panel-title class="panel-title">
                <span class="link_image"
                  ><img
                    src="assets/images/side_nav/icons8-company-50.svg"
                    width="20"
                    height="18"
                    alt=""
                /></span>
                Pipeline Management
              </mat-panel-title>
              <mat-icon *ngIf="!example3.expanded"
                >keyboard_arrow_down</mat-icon
              >
              <mat-icon *ngIf="example3.expanded"
                >keyboard_arrow_right</mat-icon
              >
            </mat-expansion-panel-header>
            <mat-list>
              <a
                [routerLink]="['/pipeline/pipelinedetails']"
                style="text-decoration: none;"
                ><mat-list-item>Pipeline Registration</mat-list-item>
              </a>
              <a
                [routerLink]="['/pipelinelicence']"
                style="text-decoration: none;"
                ><mat-list-item>Pipeline Licence Management</mat-list-item>
              </a>
              <a [routerLink]="['/taskactions']" style="text-decoration: none;"
                ><mat-list-item>Task Progress</mat-list-item>
              </a>

              <a
                [routerLink]="['/pipeline/pipelinetemplate']"
                style="text-decoration: none;"
                ><mat-list-item>Template Management</mat-list-item>
              </a>

              <a
                [routerLink]="['/stakeholderrep']"
                style="text-decoration: none;"
                ><mat-list-item>Stakeholder Reps</mat-list-item>
              </a>
              <a
                [routerLink]="['/stakeholderresponse']"
                style="text-decoration: none;"
                ><mat-list-item>Stakeholder Response</mat-list-item>
              </a>
            </mat-list>
          </mat-expansion-panel>
          <mat-expansion-panel class="mat-elevation-z0" hideToggle #example3>
            <mat-expansion-panel-header>
              <mat-panel-title class="panel-title">
                <span class="link_image"
                  ><img
                    src="assets/images/side_nav/icons8-company-50.svg"
                    width="20"
                    height="18"
                    alt=""
                /></span>
                Encroachment
              </mat-panel-title>
              <mat-icon *ngIf="!example3.expanded"
                >keyboard_arrow_down</mat-icon
              >
              <mat-icon *ngIf="example3.expanded"
                >keyboard_arrow_right</mat-icon
              >
            </mat-expansion-panel-header>
            <mat-list>
              <a [routerLink]="['/encroachment']" style="text-decoration: none;"
                ><mat-list-item>Registration</mat-list-item>
              </a>
            </mat-list>
          </mat-expansion-panel>

          <mat-expansion-panel class="mat-elevation-z0" hideToggle #example3>
            <mat-expansion-panel-header>
              <mat-panel-title class="panel-title">
                <span class="link_image"
                  ><img
                    src="assets/images/side_nav/icons8-company-50.svg"
                    width="20"
                    height="18"
                    alt=""
                /></span>
                ADR
              </mat-panel-title>
              <mat-icon *ngIf="!example3.expanded"
                >keyboard_arrow_down</mat-icon
              >
              <mat-icon *ngIf="example3.expanded"
                >keyboard_arrow_right</mat-icon
              >
            </mat-expansion-panel-header>
            <mat-list>
              <a [routerLink]="['/adr']" style="text-decoration: none;"
                ><mat-list-item>Registration</mat-list-item>
              </a>
            </mat-list>
          </mat-expansion-panel>

          <mat-expansion-panel class="mat-elevation-z0" hideToggle #example3>
            <mat-expansion-panel-header>
              <mat-panel-title class="panel-title">
                <span class="link_image"
                  ><img
                    src="assets/images/side_nav/icons8-company-50.svg"
                    width="20"
                    height="18"
                    alt=""
                /></span>
                Staff
              </mat-panel-title>
              <mat-icon *ngIf="!example3.expanded"
                >keyboard_arrow_down</mat-icon
              >
              <mat-icon *ngIf="example3.expanded"
                >keyboard_arrow_right</mat-icon
              >
            </mat-expansion-panel-header>
            <mat-list>
              <a
                [routerLink]="['/staffregister']"
                style="text-decoration: none;"
                ><mat-list-item>Registration</mat-list-item>
              </a>
            </mat-list>
          </mat-expansion-panel>

          <mat-expansion-panel class="mat-elevation-z0" hideToggle #example>
            <mat-expansion-panel-header>
              <mat-panel-title class="panel-title">
                <span class="link_image"
                  ><img
                    src="assets/images/side_nav/setting.svg"
                    width="20"
                    height="18"
                    alt=""
                /></span>
                Settings
              </mat-panel-title>
              <mat-icon *ngIf="!example.expanded">keyboard_arrow_down</mat-icon>
              <mat-icon *ngIf="example.expanded">keyboard_arrow_right</mat-icon>
            </mat-expansion-panel-header>
            <mat-list>
              <a [routerLink]="['/bank']" style="text-decoration: none;"
                ><mat-list-item>Bank</mat-list-item>
              </a>
              <a [routerLink]="['/appconfig']" style="text-decoration: none;"
                ><mat-list-item>Map Config</mat-list-item>
              </a>
              <a [routerLink]="['/hierarchy']" style="text-decoration: none;"
                ><mat-list-item>Hierarchy</mat-list-item>
              </a>
              <a
                [routerLink]="['/pipelinelicensestakeholder']"
                style="text-decoration: none;"
                ><mat-list-item>PipelineLicenseStakeholder</mat-list-item>
              </a>
              <a
                [routerLink]="['/file-location']"
                style="text-decoration: none;"
                ><mat-list-item>File Location</mat-list-item>
              </a>
              <a [routerLink]="['/continent']" style="text-decoration: none;"
                ><mat-list-item>Continent</mat-list-item>
              </a>
              <a [routerLink]="['/title']" style="text-decoration: none;"
                ><mat-list-item>Title</mat-list-item>
              </a>
              <a
                [routerLink]="['/encroachmentstatus']"
                style="text-decoration: none;"
                ><mat-list-item>Encroachment Status</mat-list-item>
              </a>
              <a
                [routerLink]="['/encroachmenttype']"
                style="text-decoration: none;"
                ><mat-list-item>Encroachment Type</mat-list-item>
              </a>
              <a [routerLink]="['/company']" style="text-decoration: none;"
                ><mat-list-item>Company</mat-list-item>
              </a>
              <a
                [routerLink]="['/paymentstatus']"
                style="text-decoration: none;"
                ><mat-list-item>Payment Status</mat-list-item>
              </a>
              <a
                [routerLink]="['/ownershiptype']"
                style="text-decoration: none;"
                ><mat-list-item>Ownership Type</mat-list-item>
              </a>
              <a
                [routerLink]="['/accountablefunction']"
                style="text-decoration: none;"
                ><mat-list-item>Accountable Function</mat-list-item>
              </a>
              <a [routerLink]="['/group']" style="text-decoration: none;"
                ><mat-list-item>Group</mat-list-item>
              </a>
              <a [routerLink]="['/function']" style="text-decoration: none;"
                ><mat-list-item>Function</mat-list-item>
              </a>
              <a [routerLink]="['/bank']" style="text-decoration: none;"
                ><mat-list-item>Bank</mat-list-item>
              </a>
              <a [routerLink]="['/assetstatus']" style="text-decoration: none;"
                ><mat-list-item>AssetStatus</mat-list-item>
              </a>
              <a
                [routerLink]="['/correspondenceteam']"
                style="text-decoration: none;"
                ><mat-list-item>Correspondence Team</mat-list-item>
              </a>
              <a
                [routerLink]="['/correspondencecompany']"
                style="text-decoration: none;"
                ><mat-list-item>Correspondence Company</mat-list-item>
              </a>
              <a [routerLink]="['/requesttype']" style="text-decoration: none;"
                ><mat-list-item>Request Type</mat-list-item>
              </a>
              <a
                [routerLink]="['/securityclassification']"
                style="text-decoration: none;"
                ><mat-list-item>Security Classification</mat-list-item>
              </a>
              <a
                [routerLink]="['/documenttypecode']"
                style="text-decoration: none;"
                ><mat-list-item>DocumentType Code</mat-list-item>
              </a>
              <a
                [routerLink]="['/measuringfactor']"
                style="text-decoration: none;"
                ><mat-list-item>Measuring Factor</mat-list-item>
              </a>
              <a [routerLink]="['/category']" style="text-decoration: none;"
                ><mat-list-item>Category</mat-list-item>
              </a>
              <a [routerLink]="['/rightheld']" style="text-decoration: none;"
                ><mat-list-item>RightHeld</mat-list-item>
              </a>
              <a
                [routerLink]="['/landusestatus']"
                style="text-decoration: none;"
                ><mat-list-item>Land Use Status</mat-list-item>
              </a>
              <a
                [routerLink]="['/bankingstatus']"
                style="text-decoration: none;"
                ><mat-list-item>Banking Status</mat-list-item>
              </a>
              <a [routerLink]="['/currency']" style="text-decoration: none;"
                ><mat-list-item>Currency</mat-list-item>
              </a>
              <a [routerLink]="['/purpose']" style="text-decoration: none;"
                ><mat-list-item>Purpose</mat-list-item>
              </a>
              <a [routerLink]="['/measure']" style="text-decoration: none;"
                ><mat-list-item>Measure</mat-list-item>
              </a>
              <a [routerLink]="['/community']" style="text-decoration: none;"
                ><mat-list-item>Community</mat-list-item>
              </a>
              <a [routerLink]="['/lga']" style="text-decoration: none;"
                ><mat-list-item>LGA</mat-list-item>
              </a>
              <a [routerLink]="['/state']" style="text-decoration: none;"
                ><mat-list-item>State</mat-list-item>
              </a>
              <a [routerLink]="['/country']" style="text-decoration: none;"
                ><mat-list-item>Country</mat-list-item>
              </a>
              <a [routerLink]="['/ratestatus']" style="text-decoration: none;"
                ><mat-list-item>Rate Status</mat-list-item>
              </a>
              <a [routerLink]="['/community']" style="text-decoration: none;"
                ><mat-list-item>Community</mat-list-item>
              </a>
              <a
                [routerLink]="['/incidentsubcat']"
                style="text-decoration: none;"
                ><mat-list-item>Incident Subcategory</mat-list-item>
              </a>
              <a [routerLink]="['/incidentcat']" style="text-decoration: none;"
                ><mat-list-item>Incident Category</mat-list-item>
              </a>
              <a
                [routerLink]="['/incidentquantum']"
                style="text-decoration: none;"
                ><mat-list-item>Incident Quantum</mat-list-item>
              </a>
              <a
                [routerLink]="['/subsubgrouptype']"
                style="text-decoration: none;"
                ><mat-list-item>SubSubGroupType</mat-list-item>
              </a>
              <a
                [routerLink]="['/subsubgrouptypecat']"
                style="text-decoration: none;"
                ><mat-list-item>SubSub GroupType Category</mat-list-item>
              </a>
              <a [routerLink]="['/quantum']" style="text-decoration: none;"
                ><mat-list-item>Quantum</mat-list-item>
              </a>
              <a [routerLink]="['/counseltype']" style="text-decoration: none;"
                ><mat-list-item>CounselType</mat-list-item>
              </a>
              <a [routerLink]="['/cofostatus']" style="text-decoration: none;"
                ><mat-list-item>CofOStatus</mat-list-item>
              </a>
              <a [routerLink]="['/accessright']" style="text-decoration: none;"
                ><mat-list-item>Access Right</mat-list-item>
              </a>
              <a [routerLink]="['/pole']" style="text-decoration: none;"
                ><mat-list-item>Pole</mat-list-item>
              </a>
              <a [routerLink]="['/damagestatus']" style="text-decoration: none;"
                ><mat-list-item>DamageStatus</mat-list-item>
              </a>
              <a
                [routerLink]="['/lessorreptype']"
                style="text-decoration: none;"
                ><mat-list-item>LessorRepType</mat-list-item>
              </a>
              <a
                [routerLink]="['/licensestatus']"
                style="text-decoration: none;"
                ><mat-list-item>License Status</mat-list-item>
              </a>
              <a [routerLink]="['/documentcat']" style="text-decoration: none;"
                ><mat-list-item>Document Category</mat-list-item>
              </a>
              <a [routerLink]="['/yearofsuit']" style="text-decoration: none;"
                ><mat-list-item>Year Of Suit</mat-list-item>
              </a>
              <a
                [routerLink]="['/lossofuseitems']"
                style="text-decoration: none;"
                ><mat-list-item>Loss of Use Items</mat-list-item>
              </a>
              <a [routerLink]="['/actionparty']" style="text-decoration: none;"
                ><mat-list-item>Correspondence Action Party</mat-list-item>
              </a>
              <a [routerLink]="['/landprefix']" style="text-decoration: none;"
                ><mat-list-item>Land Prefix</mat-list-item>
              </a>
              <a [routerLink]="['/itemtype']" style="text-decoration: none;"
                ><mat-list-item>ItemType</mat-list-item>
              </a>
              <a [routerLink]="['/lorp']" style="text-decoration: none;"
                ><mat-list-item>Lorp</mat-list-item>
              </a>
              <a [routerLink]="['/network']" style="text-decoration: none;"
                ><mat-list-item>Network</mat-list-item>
              </a>
              <a [routerLink]="['/subgroup']" style="text-decoration: none;"
                ><mat-list-item>Subgroup</mat-list-item>
              </a>
              <a [routerLink]="['/leaseex']" style="text-decoration: none;"
                ><mat-list-item>Lease Expiration</mat-list-item>
              </a>
              <a [routerLink]="['/documenttype']" style="text-decoration: none;"
                ><mat-list-item>Document Type</mat-list-item>
              </a>
              <a
                [routerLink]="['/divestmentstatus']"
                style="text-decoration: none;"
                ><mat-list-item>Divestment Status</mat-list-item>
              </a>
              <a [routerLink]="['/deliverytype']" style="text-decoration: none;"
                ><mat-list-item>Delivery Type</mat-list-item>
              </a>
              <a [routerLink]="['/damagelist']" style="text-decoration: none;"
                ><mat-list-item>Damage List</mat-list-item>
              </a>
              <a
                [routerLink]="['/cleanupstatus']"
                style="text-decoration: none;"
                ><mat-list-item>Cleanup Status</mat-list-item>
              </a>
              <a [routerLink]="['/claimtype']" style="text-decoration: none;"
                ><mat-list-item>ClaimType</mat-list-item>
              </a>
              <a
                [routerLink]="['/cabinetshelfref']"
                style="text-decoration: none;"
                ><mat-list-item>CabinetShelfRef</mat-list-item>
              </a>
              <a [routerLink]="['/batch']" style="text-decoration: none;"
                ><mat-list-item>Bank</mat-list-item>
              </a>
              <a [routerLink]="['/addresstype']" style="text-decoration: none;"
                ><mat-list-item>Address Type</mat-list-item>
              </a>
              <a
                [routerLink]="['/acquisitiontype']"
                style="text-decoration: none;"
                ><mat-list-item>AcquisitionType</mat-list-item>
              </a>
              <a
                [routerLink]="['/expirationstatus']"
                style="text-decoration: none;"
                ><mat-list-item>Expiration Status</mat-list-item>
              </a>
              <a
                [routerLink]="['/facilityasset']"
                style="text-decoration: none;"
                ><mat-list-item>FacilityAsset</mat-list-item>
              </a>
              <a [routerLink]="['/ipstatus']" style="text-decoration: none;"
                ><mat-list-item>IPStatus</mat-list-item>
              </a>
              <a [routerLink]="['/issuedcat']" style="text-decoration: none;"
                ><mat-list-item>Issued Category</mat-list-item>
              </a>
              <a [routerLink]="['/subsubgroup']" style="text-decoration: none;"
                ><mat-list-item>SubSubGroup</mat-list-item>
              </a>
              <a [routerLink]="['/racktrayref']" style="text-decoration: none;"
                ><mat-list-item>RackTrayRef</mat-list-item>
              </a>
              <a
                [routerLink]="['/obligationperiod']"
                style="text-decoration: none;"
                ><mat-list-item>Obligation Period</mat-list-item>
              </a>
              <a
                [routerLink]="['/requestsubcat']"
                style="text-decoration: none;"
                ><mat-list-item>Request Subcategory</mat-list-item>
              </a>
              <a [routerLink]="['/geo-datum']" style="text-decoration: none;"
                ><mat-list-item>Geo Datum</mat-list-item>
              </a>
              <a
                [routerLink]="['/activitystatus']"
                style="text-decoration: none;"
                ><mat-list-item>Activity Status</mat-list-item>
              </a>
              <a
                [routerLink]="['/pipelinegrade']"
                style="text-decoration: none;"
                ><mat-list-item>Pipeline Grade</mat-list-item>
              </a>
              <a
                [routerLink]="['/assetlocation']"
                style="text-decoration: none;"
                ><mat-list-item>Pipeline Asset Location </mat-list-item>
              </a>
            </mat-list>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </mat-sidenav>
    <mat-sidenav-content>
      <ng-content></ng-content>
    </mat-sidenav-content>
    <!-- CONTENT -->
  </mat-sidenav-container>
</div>
